// eslint-disable-next-line import/named
import { genericCoworkerCompanionAPICall } from "../../connexionApi/connexionApi";
import { UserResponse, UsersResponse } from "./UsersTypes";
import { toast } from "react-toastify";
const ENDPOINT_USERS = "users";

const getUsers = (token: string) => {
  const usersResult =  genericCoworkerCompanionAPICall(
    token,
    "GET",
    ENDPOINT_USERS,
    ""
  )
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as UsersResponse);

  return usersResult;
};

const getUserById = (token: string) => {
  const endpoint = `${ENDPOINT_USERS}/me`;

  const usersResult = genericCoworkerCompanionAPICall(token, "GET", endpoint, "")
    .then((response) => response.json())
    .then((jsonResponse) => jsonResponse as UserResponse);

  return usersResult;
};

const createUser = async (token: string) => {
  const ENDPOINT_RESERVATIONS = `Users/`;

  const userResult =  genericCoworkerCompanionAPICall(
    token,
    "POST",
    ENDPOINT_RESERVATIONS,
    ""
  )

  return userResult;

};


const DefaultSpace = async (token: string, idDefaultSpace: number) => {
  const userAPI: UserResponse = await getUserById(token);
  const BODY = JSON.stringify({
    "id": userAPI.id,
    "lastName": userAPI.lastName,
    "firstName": userAPI.firstName,
    "email": userAPI.email,
    "isSigned": userAPI.isSigned,
    "oktaUid": userAPI.oktaUid,
    "departmentId": userAPI.departmentId,
    "roleId": userAPI.roleId
  });
  const ENDPOINT_USERS_UPDATE = `Users/${userAPI.id}/${idDefaultSpace}/defaultSpace`
  const userResult =  genericCoworkerCompanionAPICall(
    token,
    "PUT",
    ENDPOINT_USERS_UPDATE,
    BODY
  )

  void toast.promise(userResult,
  {
    pending: 'Default space change in progress...',
    error: 'Error please contact support 🤯'
  });
  return userResult;
};

const ServiceUser = async (token: string, idService: number) => {
  const userAPI: UserResponse = await getUserById(token);
  const BODY = JSON.stringify({
    "id": userAPI.id,
    "lastName": userAPI.lastName,
    "firstName": userAPI.firstName,
    "email": userAPI.email,
    "isSigned": userAPI.isSigned,
    "oktaUid": userAPI.oktaUid,
    "departmentId": userAPI.departmentId,
    "roleId": userAPI.roleId
  });
  const ENDPOINT_USERS_UPDATE = `Users/${userAPI.id}/${idService}/service`
  console.log(ENDPOINT_USERS_UPDATE);
  const userResult =  genericCoworkerCompanionAPICall(
    token,
    "PUT",
    ENDPOINT_USERS_UPDATE,
    BODY
  )

  void toast.promise(userResult,
    {
      pending: 'Service change in progress...',
      error: 'Error please contact support 🤯'
    });
  return userResult;
};

const SignUser = async (token: string) => {
  const userAPI: UserResponse = await getUserById(token);
  const BODY = JSON.stringify({
    "id": userAPI.id,
    "lastName": userAPI.lastName,
    "firstName": userAPI.firstName,
    "email": userAPI.email,
    "oktaUid": userAPI.oktaUid,
    "departmentId": userAPI.departmentId,
    "roleId": userAPI.roleId
  });
  const ENDPOINT_USERS_UPDATE = `Users/${userAPI.id}/charterSign`
  const userResult =  genericCoworkerCompanionAPICall(
    token,
    "PUT",
    ENDPOINT_USERS_UPDATE,
    BODY
  )

  void toast.promise(userResult,
    {
      pending: 'Signing in progress...',
      error: 'Error please contact support 🤯'
    });
  return userResult;
};

export { getUsers, getUserById, createUser, SignUser, DefaultSpace, ServiceUser };
